import store from "@/store";

export default {
  bind(el, binding, vnode) {
    // 添加点击事件监听器
    const vm = vnode.context;
    const originalClickHandler = vm[binding.expression];

    el.addEventListener("click", function (event) {
      const { isLogin } = store.getters;

      if (!isLogin) {
        event.stopPropagation();
        event.preventDefault();
        vm.$tools.loginAuthTips();
      } else {
        if (typeof originalClickHandler === "function") {
          const { arg0, arg1, arg2, arg3 } = vnode.data.attrs || {};
          const args = arg0 ? [event, arg1, arg2, arg3] : [arg1, arg2, arg3];
          originalClickHandler.call(vm, ...args);
        }
      }
    });
  },
  unbind(el) {
    el.removeEventListener("click", el._clickHandler);
  },
};
